import React, { useState, useEffect  } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom'
import {
  Container,
  Row,
  Col,
} from 'reactstrap';
import 'react-overlay-loader/styles.css';
import * as UserActions from '../../actions/UserActions'
// import * as MyAPI from '../../utils/MyAPI'
import Header from './parts/Header'
import { loginWithToken } from '../../utils/Helper'
import Alert from 'react-s-alert';
import * as Helper from '../../utils/Helper'
import { Loader } from 'react-overlay-loader';
import 'react-overlay-loader/styles.css';

// Dashboard
const Dashboard = (props) => {

  let navigate = useNavigate()
  // user_state
  let login_token = useSelector(state => {
    if (state.user && state.user.login_token) {
      return state.user.login_token
    } else {
      return ''
    }
  })
  let user_state_createdAt = useSelector(state => {
    if (state.user && state.user.createdAt) {
      return state.user.createdAt
    } else {
      return ''
    }
  })
  let user_info = useSelector(state => {
    if (state.user && state.user.user_info) {
      return state.user.user_info
    } else {
      return ''
    }
  })

  let dispatch = useDispatch();
  let [loading, setLoading] = useState(false);
  // let [issuedThisMonth, setIssuedThisMonth] = useState(0);
  // let [issuedLastMonth, setIssuedLastMonth] = useState(0);
  // let [sentenceApproved, setSentenceApproved] = useState(0);
  // let [wakachiApproved, setWakachiApproved] = useState(0);
  // let [sentencePending, setSentencePending] = useState(0);
  // let [wakachiPending, setWakachiPending] = useState(0);

  // componentDidMount
  useEffect(() => {
    _firstScript()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user_info]);

  let _firstScript = async () => {

    if (!login_token) {
      let _rtnObj = await Helper.loginWithToken()
      if (_rtnObj.status === true) {

        let _login_token = _rtnObj.token_params.login_token
        dispatch(UserActions.loginWithEmail(_rtnObj.token_params))

        navigate("/account")

        return;
      } else {
        // redirect
        navigate("/")
        return;
      }
    }

    if (user_state_createdAt) {
      let diff = new Date().getTime() - user_state_createdAt.getTime()
      if ( diff < 60*60*1000 ) {

        navigate("/account")

        return;
      }
    }

    let _rtnObj = await loginWithToken(login_token)

    if (_rtnObj.status === true) {

      // login ok
      dispatch(UserActions.loginWithEmail(_rtnObj.token_params))

      navigate("/account")

    } else {

      // redirect
      navigate("/")
    }
  }

  // get statistics
  let _getStatistics = async (_login_token) => {

    return

    setLoading(true)

    try {

      // // get voice to check
      // const results_1 = await MyAPI.getStatistics({
      //   login_token: _login_token,
      // })
      // if (results_1.status !== "success") {
      //   throw Error(results_1.message)
      // }

    } catch (err) {
      console.log("err: ", err )

      Alert.error(err.message, {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });

    }
    setLoading(false)
  }

  return (
    <div style={{
      backgroundColor: '#ffffff',
      // backgroundColor: 'green',
    }}>
      {/* header */}
      <Header />

      {/* main */}
      <Container style={{
        marginTop: 40,
      }}>

        {/* main */}
        <div className="shadow2dp" style={{
          backgroundColor: '#ffffff',
          padding: 20,
          fontSize: 20,
        }}>

          <Row>
            <Col md="12" xs="12" style={{
              textAlign: 'left',
              fontSize: 22,
            }}>
              {/*<span>
                学習システムTOP
              </span>*/}
            </Col>
          </Row>

        </div>

      </Container>

      {/* loading */}
      <Loader fullPage={true} loading={loading} />

    </div>
  )
}

export default Dashboard
